import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    console.log('simple video', this.element);
    this.element.play();
  }

  disconnect() {
    console.log('simple video DISCONNECT');
    this.element.pause();
  }
}

